// 证书异常状态枚举
export const CertificateAbnormalStatusEnums = {
  // 正常
  NORMAL: '0',
  // 暂停
  PAUSED: '1',
  // 撤销
  REVOKED: '2',
  // 失效
  INVALID: '3'
}

export const CertificateAbnormalStatusList = [
  { value: CertificateAbnormalStatusEnums.PAUSED, label: '暂停' },
  { value: CertificateAbnormalStatusEnums.REVOKED, label: '撤销' },
  { value: CertificateAbnormalStatusEnums.INVALID, label: '失效' }
]

// 是否为异常状态：空值或“正常(0)”均走正常展示流程
export function isCertificateAbnormal(status) {
  return !!status && status !== CertificateAbnormalStatusEnums.NORMAL
}
